import { LayersOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PartFinderBatch } from '@/api/generatedApi';
import { pluralize } from '@/utils/format';
import { THUMBNAIL_SIZE } from './PartFinderThumbnailHover';

// Deliberately not a ThumbnailFrame: the frame's filled tile reads as a thumbnail that failed to
// load, and a batch is a different thing rather than a picture that is missing. It keeps the
// frame's footprint so rows stay aligned, and nothing else.
const StackMark = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  flexShrink: 0,
});

const StackIcon = styled(LayersOutlined)(({ theme }) => ({
  fontSize: '24px',
  color: theme.palette.text.secondary,
}));

export const PartFinderBatchThumbnail = ({ batch }: { batch: Pick<PartFinderBatch, 'breakdown'> }) => {
  const label = `Batch of ${pluralize(batch.breakdown.total, 'report', 'reports')}`;

  return (
    <Tooltip title={label} placement='right'>
      <StackMark aria-label={label}>
        <StackIcon />
      </StackMark>
    </Tooltip>
  );
};
